import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

type Props = {
	approvalSteps: ReactNode[];
};

export function ApprovalsStepBundle(props: Props) {
	const { approvalSteps } = props;
	return (
		<ApprovalStepsList>
			{approvalSteps.map((approvalStep, index) => (
				<ApprovalStepItem key={index}>{approvalStep}</ApprovalStepItem>
			))}
		</ApprovalStepsList>
	);
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ApprovalStepsList = styled.ul<{
	children?: ReactNode;
}>({
	listStyle: 'none',
	padding: 0,
	marginBottom: token('space.300'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ApprovalStepItem = styled.li<{
	children?: ReactNode;
}>({
	paddingTop: token('space.100'),
	paddingRight: 0,
	paddingBottom: token('space.100'),
	paddingLeft: 0,
});
